<div>

<mat-dialog-content  class="sku-dialog-content" style="text-align: center;">
    <button mat-icon-button class="close-button" disableRipple [mat-dialog-close]="true">
        <mat-icon class="close-icon" >close</mat-icon>
    </button>

    <img alt="" [src]="skuInfoImage" [ngStyle]="{'height.vh': data.sku.height*CONFIG.MMTOPIXCEL/CONFIG.HEIGHTCONSTANT , 
    'width.vw': data.sku.diameter*CONFIG.MMTOPIXCEL/CONFIG.WIDTHCONSTANT, 'border-radius':0,  margin:'20px 0'}" />

    <p>{{data.sku.sku_face}}</p>

    <mat-grid-list cols="2" class="sku-info-list-grid" rowHeight="3:1">
        <mat-grid-tile>
            <div class="sku-info-header">Category</div>
            <div class="sku-info">{{data.sku.category}}</div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="sku-info-header">Pack type</div>
            <div class="sku-info">{{data.sku.category}}</div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="sku-info-header">Shelf</div>
            <div class="sku-info">{{data.sku.shelf_type}}</div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="sku-info-header">Width</div>
            <div class="sku-info">{{data.sku.diameter}} mm</div>
        </mat-grid-tile>
        <mat-grid-tile>
            <div class="sku-info-header">Height</div>
            <div class="sku-info">{{data.sku.diameter}} mm</div>
        </mat-grid-tile>
     
    </mat-grid-list>

</mat-dialog-content>
</div>